"use strict";

exports.__esModule = true;
exports.ForgotPasswordScreen = ForgotPasswordScreen;
exports.forgotPassword = forgotPassword;
var _react = _interopRequireWildcard(require("react"));
var _reactFinalForm = require("react-final-form");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _FormGroupField = require("../../Form/FormGroupField");
var _Env = require("../../Env");
var _Text = require("../../Core/Text");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var EditorBody = _styledComponents["default"].div.withConfig({
  displayName: "ForgotPasswordScreen__EditorBody",
  componentId: "sc-11oc9ur-0"
})(["display:flex;overflow:auto;flex:1;flex-direction:column;padding:0.5rem;margin:auto;background:", ";color:", ";height:100vh;.", "{color:", " !important;}.", "{background:#ffffff !important;color:", " !important;}"], function (props) {
  return props.theme.LandingScreenColor;
}, function (props) {
  return props.theme.LandingScreenTextColor;
}, _core.Classes.LABEL, function (props) {
  return props.theme.LandingScreenTextColor;
}, _core.Classes.INPUT, function (props) {
  return props.theme.LandingScreenTextColor;
});
function ForgotPasswordScreen() {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var _useState = (0, _react.useState)(false),
    showCard = _useState[0],
    setShowCard = _useState[1];
  var _useState2 = (0, _react.useState)(),
    cardMessage = _useState2[0],
    setCardMessage = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    successSend = _useState3[0],
    setSuccessSend = _useState3[1];
  var env = _react["default"].useContext(_Env.EnvContext);
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var clientId = env.clientId,
    clientSecret = env.clientSecret,
    plant = env.plant;
  var handleSubmit = function handleSubmit(values) {
    var data = {
      grant_type: "password",
      username: values.username,
      client_id: clientId,
      client_secret: clientSecret
    };
    forgotPassword(env.apiURL, plant, data).then(function (result) {
      if (result.ok) {
        setCardMessage(translate("ForgotPasswordScreen.success.msg", "We have sent you an email to reset your password"));
      } else if (result.status === 404) {
        setSuccessSend(false);
        setCardMessage(translate("ForgotPasswordScreen.fail.invalidUser.msg", "Invalid username"));
      } else {
        setSuccessSend(false);
        setCardMessage(translate("ForgotPasswordScreen.fail.msg", "Something went wrong"));
      }
      setShowCard(true);
    });
  };
  return /*#__PURE__*/_react["default"].createElement(EditorBody, null, showCard ? /*#__PURE__*/_react["default"].createElement(_core.Card, {
    interactive: true,
    elevation: _core.Elevation.TWO,
    style: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      margin: "auto",
      padding: "0",
      border: "none",
      background: "#ffffff",
      maxWidth: "375px",
      textAlign: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    "data-testid": "ForgotPasswordScreen.msg.icon",
    icon: successSend ? _icons.IconNames.TICK_CIRCLE : _icons.IconNames.BAN_CIRCLE,
    size: 30,
    intent: successSend ? _core.Intent.SUCCESS : _core.Intent.DANGER,
    style: {
      margin: "8px auto 0 auto"
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    style: {
      margin: "8px 0",
      color: theme.LandingScreenTextColor
    }
  }, cardMessage)) : /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      maxWidth: "500px",
      margin: "auto",
      border: "#000000",
      background: "#ffffff",
      borderRadius: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
    onSubmit: handleSubmit
  }, function (_ref) {
    var handleSubmit = _ref.handleSubmit,
      pristine = _ref.pristine,
      invalid = _ref.invalid;
    return /*#__PURE__*/_react["default"].createElement("form", {
      onSubmit: handleSubmit,
      style: {
        minWidth: "400px",
        padding: "14px",
        margin: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Label, {
      style: {
        backgroundColor: "#ffffff",
        fontSize: theme.fontSizeMedium,
        textAlignLast: "center"
      }
    }, translate("ForgotPasswordScreen.title.label", "Password Reset")), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "username",
      label: translate("ForgotPasswordScreen.username.label", "Please enter your username")
    }, function (_ref2) {
      var input = _ref2.input;
      return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({}, input, {
        type: "text",
        style: {
          width: "100%",
          bakground: "#ffffff"
        }
      }));
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      style: {
        width: "100%"
      },
      type: "submit",
      icon: _icons.IconNames.FLOPPY_DISK,
      intent: _core.Intent.PRIMARY,
      text: translate("ForgotPassword.submitButton.text", "Submit"),
      disabled: pristine || invalid
    }));
  })));
}
function forgotPassword(_x, _x2, _x3) {
  return _forgotPassword.apply(this, arguments);
}
function _forgotPassword() {
  _forgotPassword = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(api, plant, data) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, fetch(api + "/api/v1/auth/forgot-password", {
            method: "post",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams({
              grant_type: data.grant_type,
              username: data.username,
              client_id: data.client_id,
              client_secret: data.client_secret,
              plant: plant
            }),
            redirect: "follow"
          }));
      }
    }, _callee);
  }));
  return _forgotPassword.apply(this, arguments);
}